export const onGoalCompleted = (data, get) => {
  const { setGoalCompleted } = get();
  const { goalId, userId, completionDate } = data;
  setGoalCompleted(goalId, userId, completionDate);
};
